import { Controller } from "@hotwired/stimulus"

// Controla la subida de imagen de portada con drag-and-drop
// Uso:
// - En el contenedor: data-controller="cover-upload" data-cover-upload-work-group-id-value="ID"
// - En el formulario: data-cover-upload-target="form"
// - En el input de archivo: data-cover-upload-target="fileInput"
export default class extends Controller {
  static targets = ["form", "fileInput"]
  static values = { workGroupId: Number }

  connect() {
    console.log("Cover Upload controller connected for WorkGroup", this.workGroupIdValue)
  }

  // Manejar click para abrir selector de archivos
  triggerUpload(event) {
    event.preventDefault()
    this.fileInputTarget.click()
  }

  // Manejar selección de archivo desde el input
  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.uploadFile(file)
    }
  }

  // Manejar eventos de drag and drop
  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'copy'
    this.addDragStyles()
  }

  handleDragEnter(event) {
    event.preventDefault()
    this.addDragStyles()
  }

  handleDragLeave(event) {
    event.preventDefault()
    // Solo remover estilos si realmente salimos del elemento
    if (!this.element.contains(event.relatedTarget)) {
      this.removeDragStyles()
    }
  }

  handleDrop(event) {
    event.preventDefault()
    this.removeDragStyles()
    
    const files = event.dataTransfer.files
    if (files.length > 0) {
      const file = files[0]
      if (this.isValidImageFile(file)) {
        this.uploadFile(file)
      } else {
        this.showError("Por favor selecciona un archivo de imagen válido (PNG, JPG, JPEG)")
      }
    }
  }

  // Validar que el archivo sea una imagen válida
  isValidImageFile(file) {
    const validTypes = ['image/png', 'image/jpg', 'image/jpeg']
    //const maxSize = 500 * 1024 // 500KB
    
    if (!validTypes.includes(file.type)) {
      return false
    }
    
    /*if (file.size > maxSize) {
      this.showError("El archivo es demasiado grande. Máximo 500KB.")
      return false
    }*/
    
    return true
  }

  // Subir el archivo
  uploadFile(file) {
    console.log("Uploading file:", file.name)
    
    // Mostrar indicador de carga
    this.showLoading()
    
    // Crear FormData y agregar el archivo
    const formData = new FormData()
    formData.append('cover', file)
    
    // Obtener la URL del formulario
    const url = this.formTarget.action
    
    // Realizar la petición
    fetch(url, {
      method: 'PATCH',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => response.json())
    .then(data => {
      this.hideLoading()
      if (data.success) {
        this.showSuccess(data.message)
        // Recargar la página para mostrar la nueva imagen
        window.location.reload()
      } else {
        this.showError(data.message)
      }
    })
    .catch(error => {
      this.hideLoading()
      console.error('Error uploading file:', error)
      this.showError("Error al subir la imagen. Por favor intenta de nuevo.")
    })
  }

  // Estilos visuales para drag and drop
  addDragStyles() {
    this.element.classList.add('border-primary', 'bg-light')
    this.element.style.borderStyle = 'dashed'
  }

  removeDragStyles() {
    this.element.classList.remove('border-primary', 'bg-light')
  }

  // Mostrar indicador de carga
  showLoading() {
    const icon = this.element.querySelector('i')
    if (icon) {
      icon.className = 'bi bi-hourglass-split text-muted mb-3'
    }
    
    const title = this.element.querySelector('h6')
    if (title) {
      title.textContent = 'Subiendo imagen...'
    }
    
    const description = this.element.querySelector('p')
    if (description) {
      description.textContent = 'Por favor espera mientras se procesa la imagen'
    }
  }

  hideLoading() {
    const icon = this.element.querySelector('i')
    if (icon) {
      icon.className = 'bi bi-cloud-upload text-muted mb-3'
    }
    
    const title = this.element.querySelector('h6')
    if (title) {
      title.textContent = 'Agregar imagen de portada'
    }
    
    const description = this.element.querySelector('p')
    if (description) {
      description.textContent = 'Arrastra una imagen aquí o haz clic para seleccionar'
    }
  }

  // Mostrar mensajes de éxito y error
  showSuccess(message) {
    //alert(message) // Se puede mejorar con toast notifications
  }

  showError(message) {
    alert(message) // Se puede mejorar con toast notifications
  }
}
